/*
* Velvet Theme
*
* Use this file to add custom Javascript to Velvet.  Keeping your custom
* Javascript in this fill will make it easier to update Velvet. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line






  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();

(function () {
  /** Seletores básicos */
  const GROUP_SELECTOR = '[data-swatches-container]';
  const LEGEND_SELECTOR = '[data-swatches-label]';
  const RADIO_SELECTOR = 'input[type="radio"]';

  /**
   * Localiza o <label> associado ao radio e devolve o que estiver em data-swatch
   */
  function getColorName(input) {
    const label = document.querySelector(`label[for="${input.id}"][data-swatch]`);
    return label ? label.dataset.swatch : input.value;
  }

  /**
   * Atualiza o texto “COR: Nome” no legend do grupo
   */
  function updateLegend(input) {
    const group = input.closest(GROUP_SELECTOR);
    if (!group) return;

    const legend = group.querySelector(LEGEND_SELECTOR);
    if (!legend) return;

    const base = legend.querySelector('.radio__legend__label');
    if (!base) return;

    base.textContent = `COR: ${getColorName(input)}`;
  }

  /* --- Inicializa na primeira renderização --- */
  function init() {
    // radios que já vêm marcados no HTML
    document.querySelectorAll(`${GROUP_SELECTOR} ${RADIO_SELECTOR}:checked`)
            .forEach(updateLegend);
  }

  /* --- Ouvintes --- */
  // troca feita pelo usuário
  document.addEventListener('change', (e) => {
    const input = e.target;
    if (input.matches(`${GROUP_SELECTOR} ${RADIO_SELECTOR}`) && input.checked) {
      updateLegend(input);
    }
  });

  // alguns temas disparam variant:change via JS
  document.addEventListener('variant:change', init);

  // garante que rode mesmo se o script carregar antes do DOM estar pronto
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();



(function () {
  function addPopupStyles() {
    if (document.getElementById('velvet-full-popup-styles')) return;

    const style = document.createElement('style');
    style.id = 'velvet-full-popup-styles';
    style.textContent = `
      .product__popup--full-template .product__popup__inner {
        height: 100%;
        padding: 0 !important;
      }

      .product__popup--full-template .product__popup__content {
        padding: 0 !important;
      }

      .product__popup--full-template [data-popup-page-target] {
        background: #fff;
      }

      .product__popup--full-template .shopify-section:first-child {
        display: none;
      }

      .product__popup--full-template [data-aos] {
        opacity: 1 !important;
        transform: none !important;
      }
    `;

    document.head.appendChild(style);
  }

  function cleanInsertedContent(target) {
    // Remove header/footer caso venham junto por algum motivo
    target.querySelectorAll('header, footer, .site-header, .site-footer').forEach((el) => {
      el.remove();
    });

    // Remove a section main-page vazia da página
    target.querySelectorAll('[data-section-type="main-page"]').forEach((section) => {
      const wrapper = section.closest('.shopify-section') || section;
      wrapper.remove();
    });

    // Evita sections invisíveis por animação AOS não reinicializada
    target.querySelectorAll('[data-aos]').forEach((el) => {
      el.classList.add('aos-animate');
      el.removeAttribute('data-aos');
      el.removeAttribute('data-aos-anchor');
      el.removeAttribute('data-aos-delay');
      el.removeAttribute('data-aos-duration');
    });

    // Força imagens lazy a aparecerem melhor no popup
    target.querySelectorAll('img[loading="lazy"]').forEach((img) => {
      img.setAttribute('loading', 'eager');
    });
  }

  function runInsertedScripts(target) {
    target.querySelectorAll('script').forEach((oldScript) => {
      const newScript = document.createElement('script');

      Array.from(oldScript.attributes).forEach((attr) => {
        newScript.setAttribute(attr.name, attr.value);
      });

      newScript.textContent = oldScript.textContent;
      oldScript.replaceWith(newScript);
    });
  }

  function reinitTheme(target) {
    const sectionEls = target.querySelectorAll('[data-section-type][data-section-id]');

    if (
      window.Shopify &&
      window.Shopify.theme &&
      window.Shopify.theme.sections &&
      typeof window.Shopify.theme.sections.load === 'function'
    ) {
      window.Shopify.theme.sections.load('*', sectionEls);
    }

    document.dispatchEvent(new CustomEvent('theme:resize'));
    document.dispatchEvent(new CustomEvent('theme:scroll'));
    document.dispatchEvent(new CustomEvent('theme:vars'));
    window.dispatchEvent(new Event('resize'));
  }

  function initFullTemplatePopup() {
    addPopupStyles();

    document.querySelectorAll('[data-popup-page-loader]').forEach((container) => {
      if (container.dataset.popupLoaderReady === 'true') return;
      container.dataset.popupLoaderReady = 'true';

      const drawer = container.closest('[data-drawer]');
      const target = container.querySelector('[data-popup-page-target]');
      const fallback = container.querySelector('[data-popup-page-fallback]');
      const pageUrl = container.dataset.popupPageUrl;

      if (!drawer || !target || !pageUrl) return;

      const trigger = document.querySelector('[aria-controls="' + drawer.id + '"][data-drawer-toggle]');

      async function loadPageContent() {
        if (container.dataset.loaded === 'true' || container.dataset.loaded === 'loading') return;

        container.dataset.loaded = 'loading';
        target.innerHTML = '<p style="padding: 24px;">Carregando...</p>';

        try {
          const response = await fetch(pageUrl, {
            credentials: 'same-origin'
          });

          if (!response.ok) throw new Error('Erro ao carregar página: ' + response.status);

          const html = await response.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const mainContent = doc.querySelector('#MainContent');

          if (!mainContent) throw new Error('MainContent não encontrado');

          target.innerHTML = mainContent.innerHTML;

          cleanInsertedContent(target);
          runInsertedScripts(target);
          reinitTheme(target);

          container.dataset.loaded = 'true';
        } catch (error) {
          console.warn(error);
          container.dataset.loaded = 'false';

          target.innerHTML = fallback
            ? fallback.innerHTML
            : '<p style="padding: 24px;">Não foi possível carregar este conteúdo.</p>';
        }
      }

      if (trigger) {
        trigger.addEventListener('click', loadPageContent);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFullTemplatePopup);
  } else {
    initFullTemplatePopup();
  }
})();